module.exports = __webpack_public_path__ + "static/media/final_v_sm_2.c6c9c6a4.mp4";